module.exports = __webpack_public_path__ + "static/media/company6.34686969.png";